function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 16,
  fill: "#12908D",
  stroke: "white",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.3823 15.7157C12.4959 14.8088 15.2417 15.5507 17.0264 17.6776C18.9744 19.999 19.0986 23.1615 17.4212 25.0653C17.9754 24.7968 18.4971 24.4372 18.9642 23.9862L23.8664 19.2522C26.2354 16.9645 26.3013 13.1896 24.0136 10.8206C21.7259 8.45161 17.9509 8.38572 15.582 10.6734L10.6798 15.4074C10.5762 15.5074 10.4771 15.6102 10.3823 15.7157Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0306 18.5132C17.8114 20.6356 17.5823 23.2982 16.1084 24.535C14.6345 25.7717 11.9725 25.535 10.1916 23.4127C8.41078 21.2904 8.63992 18.6277 10.1138 17.3909C11.5877 16.1542 14.2497 16.3909 16.0306 18.5132Z",
  stroke: "#4A5862",
  strokeWidth: 2.6
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.0272 18.3331C12.5363 17.1705 14.3516 18.606 15.0169 19.3425C15.6821 20.0789 16.7505 22.079 15.5196 23.3353C14.2886 24.5915 12.1822 23.7583 11.2791 22.6877C10.3759 21.6171 9.51801 19.4957 11.0272 18.3331Z",
  fill: "#F3F7F7"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.7957 23.1565L15.3199 19.7486C15.3199 19.7486 16.9998 21.8662 15.4899 23.3586C13.98 24.851 11.7957 23.1565 11.7957 23.1565Z",
  fill: "#E0DEDE"
});

function SvgIconLogbookNonMetallic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogbookNonMetallic);
export default __webpack_public_path__ + "static/media/iconLogbookNonMetallic.8389faa5.svg";
export { ForwardRef as ReactComponent };